import React from 'react';
import { Box, Typography } from '@mui/material';

export const SectionEmptyBlock = () => {
  return (
    <Box sx={{
      marginTop: '4px',
    }}>
      <Typography sx={{
        color: '#363636',
        fontWeight: '400',
        fontSize: '12px',
      }}>
        There are no rules yet...
      </Typography>
    </Box>
  );
}
